import { render, staticRenderFns } from "./IconMicrosoft.vue?vue&type=template&id=3469a0c7&functional=true"
import script from "./IconMicrosoft.vue?vue&type=script&lang=js"
export * from "./IconMicrosoft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports